module.exports = __webpack_public_path__ + "img/JgIndex3.9dcbd61e.png";